import styled from 'styled-components';

/** Общие стили видов «По системам» и «Сводно ▶» экрана «Объёмы». */

/** Таблица вида — как таблица позиций (`VolumesTable`). */
export const Grid = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th,
  td {
    text-align: left;
    padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(2.5)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    vertical-align: top;
  }

  th {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: 600;
    white-space: nowrap;
  }

  th.wrap {
    white-space: normal;
    min-width: 96px;
  }

  td.num,
  th.num {
    text-align: right;
    white-space: nowrap;
  }
`;

/** Строка-заголовок группы (система, группа таблицы, строка ведомости). */
export const GroupTr = styled.tr`
  background: ${({ theme }) => theme.colors.surface};

  & > td {
    font-weight: 600;
  }
`;

/** Строка-заголовок раздела внутри группы. */
export const SectionTr = styled.tr`
  & > td {
    padding-left: ${({ theme }) => theme.spacing(8)};
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: 12px;
    font-weight: 600;
  }
`;

/** Строка доли системы под строкой ведомости. */
export const ShareTr = styled.tr`
  color: ${({ theme }) => theme.colors.text.secondary};

  & > td.label {
    padding-left: ${({ theme }) => theme.spacing(8)};
  }
`;

/** Кнопка ▶/▼ группы. */
export const Toggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
  }
`;

/** Счётчики группы после подписи. */
export const Facts = styled.span`
  margin-left: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 400;
`;

/** «⚠» в текстовом начертании (U+FE0E) — как значок расхождения шифра в «Разделе». */
export const WARN_SIGN = '⚠︎';

/** Пометка сомнения или расхождения: цвет предупреждения, текст — в подсказке. */
export const Warn = styled.span`
  margin-left: 6px;
  font-weight: 700;
  font-feature-settings: normal;
  color: ${({ theme }) => theme.colors.status.warning};
  cursor: help;
`;

/** Панель над видом: кнопки «Развернуть все / Свернуть все» и пояснение. */
export const ViewBar = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/** Ссылка-кнопка в панели вида. */
export const LinkButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
  }
`;
